<template>
  <!-- 핸드폰 入仓登记(2026-10-04 YZY) — ① 快递单号 스캔 → ② 拍照 → ③ 入仓位置号 스캔 → ④ 入仓.
       PC 入仓登记(logisInboundRegisterV0)와 같은 서버 API(inboundRegister/find·save). 일반 로그인 세션(직원 계정 showadmin) — /m/putaway 와 같다.
       바코드 인식은 MobilePutaway 와 같은 방식(BarcodeDetector → 없으면 quagga), 사진은 입고처리 핸드폰 촬영과 같은 길(S3 → importPhoto/issue·add).
       라벨 인쇄는 PC 「登记记录」에서 补打
       mode='photo' = 入库拍照(/m/import-photo, 2026-10-07 YZY) — ① 单号(快递·货主·1688) 스캔 → ② 商品/尺寸照片 촬영 → 「完成」.
       같은 카메라·스캔·업로드를 쓰고, 서버는 촬영 대기열 API(importPhotoQueue/*) — PC 入库处理 하단에 순서대로 뜬다 -->
  <div class="minreg">
    <div class="minreg__steps">
      <div v-for="s in steps" :key="s.n" :class="['minreg__stepdot', { 'is-on': step === s.n, 'is-done': step > s.n }]">
        <b>{{ s.n }}</b>{{ s.cn }}
      </div>
    </div>

    <!-- 入库拍照 — 작업자 이름(이 핸드폰에 기억) · 단호 종류 -->
    <template v-if="isPhoto">
      <div class="minreg__who">
        <small>作业人</small>
        <input v-model.trim="workerName" type="text" class="form-control form-control-sm" maxlength="30" placeholder="输入你的名字" @change="saveWorker">
      </div>
      <div v-if="step === 1" class="minreg__types">
        <button v-for="t in searchTypes" :key="t.v" type="button" :class="['btn btn-sm', searchType === t.v ? 'btn-primary' : 'btn-outline-primary']" @click="setSearchType(t.v)">{{ t.cn }}</button>
      </div>
    </template>

    <!-- 지금까지 고른 것 -->
    <div v-if="waybill" class="minreg__sum">
      <div><small>{{ isPhoto ? typeLabel : '快递单号' }}</small> <b>{{ waybill }}</b> <a href="#" class="ml-2 small" @click.prevent="reset">重新开始</a></div>
      <!-- 系统未找到 안내는 맨 아래 기록(logs) 한 줄만 — 요약칸 배너·메시지까지 3번 겹쳐 떴다(2026-10-04 YZY 실기기) -->
      <div v-if="rows.some(x => x._multi)" class="alert alert-warning py-1 small mb-1">多包裹订单(운송장이 여러 개): 这个包裹里的商品请手动勾选 — 一个单号不一定包含全部商品(이 소포에 든 상품만 직접 체크하세요)</div>
      <div class="minreg__rows">
      <div v-for="r in rows" :key="r._id" :class="['minreg__row', { 'is-rocket': r._로켓 }]">
        <label class="mb-0 d-flex align-items-center" style="gap:6px">
          <input v-model="r._checked" type="checkbox">
          <img v-if="r.옵션이미지 || r.등록이미지" :src="r.옵션이미지 || r.등록이미지" class="minreg__pimg" alt="">
          <span class="minreg__rtext">
            <b>{{ r.companyid }}</b><span v-if="leaderOf(r.companyid)" class="badge badge-info ml-1">{{ leaderOf(r.companyid) }}</span><span v-else class="badge badge-light text-danger ml-1">等待分配组长</span> · {{ r._1688 || r.화주주문번호 || '-' }} · {{ r.구매요청수량 }}
            <span class="d-block text-danger">{{ r._옵션 }}</span>
            <span v-if="r._출고" class="badge" :style="r._출고스타일">{{ r._출고 }}</span>
            <span v-if="r.입창등록" class="badge badge-warning ml-1">已登记 {{ r.입창등록.위치번호 }}</span>
          </span>
        </label>
      </div>
      </div>
      <div v-if="others.length" class="small text-muted">已入库/取消 {{ others.length }}件 不显示</div>
      <div v-if="photos.length || pendingCount" class="small mt-1">📷 {{ photos.length }}张<span v-if="isPhoto && sizeCount">(尺寸 {{ sizeCount }})</span><span v-if="pendingCount"> · 上传中 {{ pendingCount }}</span></div>
      <div v-if="location" class="mt-1"><small>入仓位置号</small> <b class="minreg__loc">{{ location }}</b></div>
    </div>

    <!-- 入库拍照 ② — 지금 찍는 사진 종류(商品照片 = 입고사진, 尺寸照片 = 사이즈사진) -->
    <div v-if="isPhoto && step === 2" class="minreg__types">
      <button v-for="k in photoKinds" :key="k.v" type="button" :class="['btn', photoKind === k.v ? 'btn-warning' : 'btn-outline-secondary']" @click="photoKind = k.v">📷 {{ k.cn }}</button>
    </div>

    <!-- ①·③ 바코드 카메라 / ② 사진 카메라 — 같은 video 하나를 쓴다 -->
    <!-- key 고정 — 위쪽 요약 칸이 생길 때 video 가 새로 만들어지면 카메라 스트림(srcObject)이 끊긴다 -->
    <!-- ①③ 바코드 단계는 가로로 긴 띠(바코드 한 줄 높이) — 보이는 띠 부분만 잘라 디코더에 넣는다(detectFrame) -->
    <div v-show="step !== 4" key="minreg-cam" :class="['minreg__cam', { 'is-band': step === 1 || step === 3, 'is-photo': step === 2 }]">
      <video ref="video" key="minreg-video" playsinline muted :class="{ 'is-on': camOn }"></video>
      <canvas ref="canvas" style="display:none"></canvas>
      <div v-if="!camOn" class="minreg__cam-off">
        <button type="button" class="btn btn-primary btn-lg" @click="startCamera">📷 打开相机</button>
        <!-- 실시간 카메라가 막힌 기기용 — ①③ 은 사진 한 장으로 인식, ② 는 기본 카메라 앱 -->
        <label class="btn btn-outline-light btn-sm mt-2 mb-0">🖼 {{ step === 2 ? '拍照/相册' : '拍照识别' }}
          <input type="file" accept="image/*" :multiple="step === 2" capture="environment" style="display:none" @change="onPhotoInput">
        </label>
        <div v-if="camError" class="small text-danger mt-2">{{ camError }}</div>
      </div>
      <template v-else>
        <div class="minreg__cam-hint">{{ step === 2 ? '拍照 — 按白色按钮' : step === 1 ? (isPhoto ? '对准单号条码' : '对准快递单条码') : '对准库位号条码' }}</div>
        <div v-if="step !== 2" class="minreg__aim"></div>
        <div v-if="flash" class="minreg__flash"></div>
        <button v-if="step === 2" type="button" class="minreg__shutter" :disabled="!camReady" aria-label="shutter" @click="capture"></button>
        <div v-if="step !== 2" class="minreg__engine">{{ engine }}</div>
      </template>
    </div>

    <!-- 수동 입력(①③) — 블루투스/USB 스캐너도 여기로 -->
    <div v-if="step === 1 || step === 3" class="minreg__input">
      <input ref="manual" v-model="manual" type="text" class="form-control" inputmode="text" autocomplete="off"
             :placeholder="step === 1 ? (isPhoto ? typeLabel : '快递单号') : '入仓位置号 例 A-01-01'" :disabled="busy" @keyup.enter="onManual">
      <button type="button" class="btn btn-success" :disabled="busy || !manual.trim()" @click="onManual">OK</button>
    </div>

    <div v-if="message" :class="['minreg__msg', { 'is-err': messageErr }]">{{ message }}</div>

    <!-- 단계 버튼 -->
    <div :class="['minreg__nav', { 'is-fixed': step === 2 }]">
      <!-- 入库拍照 — 完成 = 전송(PC 入库处理 하단에 한 줄). 업로드가 다 끝나야 누른다 -->
      <template v-if="step === 2 && isPhoto">
        <button type="button" class="btn btn-outline-secondary" :disabled="saving" @click="goStep(1)">← 上一步</button>
        <button type="button" class="btn btn-success" :disabled="saving || !checkedRows.length || !photos.length || pendingCount > 0" @click="finish">
          <span v-if="saving" class="spinner-border spinner-border-sm"></span> ✅ 完成<small>({{ photos.length }}张 · 发送到电脑)</small>
        </button>
      </template>
      <template v-else-if="step === 2">
        <button type="button" class="btn btn-outline-secondary" @click="goStep(1)">← 上一步</button>
        <button type="button" class="btn btn-primary" :disabled="!checkedRows.length && !unmatched" @click="goStep(3)">
          下一步 · 扫位置号<small>({{ photos.length ? photos.length + '张' : '不拍照' }})</small>
        </button>
      </template>
      <template v-else-if="step === 3">
        <button type="button" class="btn btn-outline-secondary" @click="goStep(2)">← 上一步</button>
      </template>
      <template v-else-if="step === 4">
        <button type="button" class="btn btn-outline-secondary" :disabled="saving" @click="goStep(3)">← 重扫位置号</button>
        <button type="button" class="btn btn-success btn-lg" :disabled="saving || (!checkedRows.length && !unmatched) || pendingCount > 0" @click="save">
          <span v-if="saving" class="spinner-border spinner-border-sm"></span> ✅ 入仓
        </button>
      </template>
    </div>
    <div v-if="step === 4 && pendingCount" class="small text-muted text-center">照片上传完后可入仓</div>

    <!-- 사진 미리보기 -->
    <div v-if="step >= 2 && (queue.length || photos.length)" class="minreg__grid">
      <div v-for="q in queue" :key="q.key" class="minreg__cell is-pending">
        <img :src="q.preview" alt="">
        <span v-if="q.error" class="minreg__badge is-err" @click="retry(q)">失败·重试</span>
        <span v-else class="minreg__badge">上传中…</span>
      </div>
      <div v-for="(u, i) in photos" :key="u + i" class="minreg__cell">
        <a :href="u" target="_blank" rel="noopener"><img :src="u" alt=""></a>
      </div>
    </div>

    <div class="minreg__logs">
      <div v-for="(l, i) in logs" :key="'l' + i" :class="['minreg__log', l.ok ? 'is-ok' : 'is-err']">
        <span class="minreg__time">{{ l.time }}</span> {{ l.text }}
      </div>
      <div v-if="!isPhoto" class="text-muted small text-center py-2">标签请在电脑「入仓登记 → 登记记录」补打</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { uploadImportPhoto } from '@/utils/importPhotoS3';
import { outboundTypeOfReq, outboundTypeText, outboundTypeStyle } from '@/utils/coupassStatusText';
import { nowText } from './putawayScan';
import FastScanner, { SCAN_FORMATS } from '@/utils/fastScanner';
import { checkLocation, locationRejectText, isStepLocked, STEP_LOCK_MS, AUTOSAVE_DELAY_MS } from './inboundScanGuard';

const DUP_MS = 2000;
// 서버 WAYBILL_RE 와 같다 — 이 형식이어야 「系统未找到」 임시 기록으로 저장된다
const WAYBILL_RE = /^[A-Za-z0-9-]{4,40}$/;
// 바코드 띠 — 보이는 띠 높이의 몇 배까지 디코더에 넣을지(손떨림 여유)
const BAND_MARGIN = 1.6;
const MAX_LOGS = 50;
// 연속 촬영 캡처 — ImportPhotoMobile 과 같은 기준
const CAPTURE_MAX_SIDE = 1920;
const CAPTURE_QUALITY = 0.85;
// 입창 때 찍는 사진 = 商品及包装照片(입고처리 사진과 같은 칸·같은 키)
const PHOTO_KIND = '입고사진';
// 이 화면은 중국어만(2026-10-04 YZY) — 공용 문구(出库形式·서버 오류)에 붙은 「(한국어)」 괄호를 떼어 보여준다
const KO_PAREN_RE = /\s*[(（][^()（）]*[가-힣][^()（）]*[)）]/g;
function noKo(t) { return String(t || '').replace(KO_PAREN_RE, ''); }
function errText(data) { return noKo(data && data.error && data.error.errorMessage); }
// 入库拍照(mode='photo') — 단호 종류는 PC 入库处理 검색 종류와 같은 값, 사진 종류는 입고사진 칸의 종류 값
const SEARCH_TYPES = [
  { v: 'tracking', cn: '快递单号' },
  { v: 'order', cn: '货主订单号' },
  { v: 'order1688', cn: '1688订单号' }
];
const PHOTO_KINDS = [
  { v: '입고사진', cn: '商品照片' },
  { v: '사이즈사진', cn: '尺寸照片' }
];
// 이 핸드폰에 기억(못 읽어도 기본값으로 동작)
const WORKER_KEY = 'importPhoto.workerName';
const SEARCH_TYPE_KEY = 'importPhoto.searchType';
function readLocal(key, def) {
  try {
    return localStorage.getItem(key) || def;
  } catch (e) {
    console.error('[入库拍照] 저장값 읽기 실패:', key, e);
    return def;
  }
}
function writeLocal(key, v) {
  try {
    localStorage.setItem(key, v);
  } catch (e) {
    console.error('[入库拍照] 저장값 쓰기 실패:', key, e);
  }
}

export default {
  name: 'MobileInboundRegister',
  props: {
    // 'inbound' = 入仓登记(/m/inbound-register), 'photo' = 入库拍照(/m/import-photo)
    mode: { type: String, default: 'inbound' }
  },
  data() {
    return {
      ownerLeader: {},   // 货主 → 组长负责人(客户和客户负责人 화면)
      steps: this.mode === 'photo' ? [
        { n: 1, cn: '扫单号' },
        { n: 2, cn: '拍照·完成' }
      ] : [
        { n: 1, cn: '扫快递单号' },
        { n: 2, cn: '拍照' },
        { n: 3, cn: '扫位置号' },
        { n: 4, cn: '入仓' }
      ],
      // 入库拍照
      searchTypes: SEARCH_TYPES,
      photoKinds: PHOTO_KINDS,
      searchType: SEARCH_TYPES.some(t => t.v === readLocal(SEARCH_TYPE_KEY, '')) ? readLocal(SEARCH_TYPE_KEY, '') : 'tracking',
      workerName: readLocal(WORKER_KEY, ''),
      photoKind: '입고사진',
      sizeCount: 0,
      step: 1,
      waybill: '',
      // 系统未找到 — 그 운송장으로 만든 임시 기록 _id(InboundRegisterLog unmatched:true). 사진·위치가 여기 붙는다
      unmatched: '',
      rows: [],
      others: [],
      location: '',
      manual: '',
      busy: false,
      saving: false,
      message: '',
      messageErr: false,
      logs: [],
      // 사진 — 올라간 주소(첫 행 기준 S3 키) / 업로드 대기열 { key, file, preview, error }
      photos: [],
      queue: [],
      working: false,
      // 카메라
      camOn: false,
      camReady: false,
      camError: '',
      engine: '',
      stream: null,
      audio: null,
      flash: false,
      // ③ 위치번호 인식 성공 → 확인 버튼 없이 바로 入仓(2026-10-04 YZY). 사진 업로드가 남았으면 끝난 뒤 저장
      autoSave: false
    };
  },
  computed: {
    isPhoto() {
      return this.mode === 'photo';
    },
    typeLabel() {
      const t = SEARCH_TYPES.find(x => x.v === this.searchType);
      return t ? t.cn : '';
    },
    checkedRows() {
      return this.rows.filter(r => r._checked);
    },
    pendingCount() {
      return this.queue.filter(q => !q.error).length;
    }
  },
  watch: {
    'queue.length'() {
      this.tryAutoSave();
    }
  },
  created() {
    this.loadOwnerLeader();
    // 바코드 연속 인식(공용) — 반응형일 필요 없어 data 밖에 둔다
    this.scanner = new FastScanner({ tag: '[手机入仓]', dupMs: DUP_MS });
  },
  beforeDestroy() {
    clearTimeout(this._autoTimer);
    this.stopCamera();
    this.queue.forEach(q => this.revoke(q));
  },
  methods: {
    // 로그 줄에 붙일 «客户 · 组长» (2026-10-18 崔凡)
    ownerTag(rows) {
      const owners = [...new Set((rows || []).map(r => r.companyid).filter(Boolean))];
      if (!owners.length) return '';
      const leaders = [...new Set(owners.map(o => this.leaderOf(o) || '等待分配组长'))];
      return ' · 客户 ' + owners.join('/') + ' · 组长 ' + leaders.join('/');
    },
    leaderOf(companyid) {
      return (this.ownerLeader && this.ownerLeader[companyid]) || '';
    },
    async loadOwnerLeader() {
      try {
        const { data } = await axios.post('/api/ownerLeader/map', {});
        if (data.요청결과 === '성공') this.ownerLeader = data.map || {};
      } catch (e) {
        console.error('组长负责人 표 읽기 실패:', e);
      }
    },
    log(text, ok) {
      this.logs.unshift({ time: nowText(), text, ok: !!ok });
      if (this.logs.length > MAX_LOGS) this.logs.length = MAX_LOGS;
    },
    say(text, err) {
      this.message = text;
      this.messageErr = !!err;
    },
    // 인식 알림 — MobilePutaway 와 같다(진동 + 짧은 삑, 실패는 낮은 음 두 번)
    feedback(ok) {
      try {
        if (navigator.vibrate) navigator.vibrate(ok ? 80 : [60, 60, 60]);
        if (!this.audio) this.audio = new (window.AudioContext || window.webkitAudioContext)();
        const play = (freq, at) => {
          const o = this.audio.createOscillator();
          const g = this.audio.createGain();
          o.frequency.value = freq;
          g.gain.value = 0.15;
          o.connect(g);
          g.connect(this.audio.destination);
          o.start(this.audio.currentTime + at);
          o.stop(this.audio.currentTime + at + 0.09);
        };
        if (ok) play(1200, 0); else { play(400, 0); play(400, 0.15); }
      } catch (e) {
        console.error('[手机入仓] 알림음 오류:', e);
      }
    },
    decorate(r) {
      const 출고 = outboundTypeOfReq(r);
      return Object.assign({}, r, {
        // 운송장이 여러 개인 주문(소포가 여러 개)은 한 번 스캔했다고 전부 入仓 처리하지 않는다 — 직접 체크(2026-10-18 崔凡 #78)
        _multi: Array.isArray(r.물류정보 && r.물류정보.운송장번호목록) && r.물류정보.운송장번호목록.length > 1,
        _checked: !(Array.isArray(r.물류정보 && r.물류정보.운송장번호목록) && r.물류정보.운송장번호목록.length > 1),
        _1688: (r.주문정보 && r.주문정보['1688주문번호']) || '',
        _옵션: [r.옵션1_중국어, r.옵션2_중국어].filter(Boolean).join(' '),
        _출고: noKo(outboundTypeText(출고)),
        _출고스타일: outboundTypeStyle(출고),
        _로켓: 출고 === '쉽먼트택배'
      });
    },
    goStep(n) {
      this.autoSave = false;
      clearTimeout(this._autoTimer);
      this.step = n;
      this.say('');
      // 단계가 바뀌는 순간: 앞 단계 스캔의 남은 글자를 비우고(그대로 두면 다음 스캔과 붙어 乱码가 된다), 잠깐 새 스캔을 받지 않는다
      this.manual = '';
      this._lockUntil = Date.now() + STEP_LOCK_MS;
      this.scanner.resetDup();
      if (n === 4) this.stopCamera();
      this.$nextTick(() => { if (this.$refs.manual) this.$refs.manual.focus(); });
    },
    reset() {
      this.queue.forEach(q => this.revoke(q));
      this.queue = [];
      this.photos = [];
      this.rows = [];
      this.others = [];
      this.waybill = '';
      this.unmatched = '';
      this.location = '';
      this.photoKind = '입고사진';
      this.sizeCount = 0;
      this.goStep(1);
    },
    saveWorker() {
      writeLocal(WORKER_KEY, this.workerName || '');
    },
    setSearchType(v) {
      this.searchType = v;
      writeLocal(SEARCH_TYPE_KEY, v);
      this.$nextTick(() => { if (this.$refs.manual) this.$refs.manual.focus(); });
    },
    // ── 카메라(MobilePutaway 와 같은 방식) ──
    async startCamera() {
      this.camError = '';
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.camError = '此浏览器不支持相机 — 请用下面的输入框';
        return;
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false
        });
        const v = this.$refs.video;
        v.srcObject = this.stream;
        v.onloadedmetadata = () => { this.camReady = true; };
        await v.play();
        this.camOn = true;
        if (v.readyState >= 1) this.camReady = true;
        // ①③ 단계에서만, 보이는 띠 부분만 인식한다. ② 는 셔터만
        this.engine = await this.scanner.start({
          video: v,
          canvas: this.$refs.canvas,
          enabled: () => this.step === 1 || this.step === 3,
          formats: () => this.scanFormats(),
          roi: video => this.cropRect(video),
          onDetect: val => this.onDetected(val)
        });
      } catch (e) {
        console.error('[手机入仓] 카메라 시작 실패:', e);
        this.camError = '相机打开失败: ' + e.message;
        this.stopCamera();
      }
    },
    // ① 운송장 / ③ 위치번호 라벨 — 실제 라벨 포맷만 찾는다(fastScanner)
    scanFormats() {
      return this.step === 1 ? SCAN_FORMATS.WAYBILL : SCAN_FORMATS.LABEL;
    },
    decodeSrc(src) {
      return this.scanner.decodeSrc(src, this.scanFormats());
    },
    stopCamera() {
      this.scanner.stop();
      if (this.stream) {
        this.stream.getTracks().forEach(t => {
          try { t.stop(); } catch (e) { console.error('[手机入仓] 카메라 정지 실패', e); }
        });
      }
      this.stream = null;
      this.camOn = false;
      this.camReady = false;
    },
    // 화면에 보이는 띠(object-fit: cover 로 가운데가 잘려 보인다) 부분만 원본 해상도로 잘라 디코더에 넣는다.
    // 띠 밖에 찍힌 다른 바코드(옆 송장·상품 바코드)를 잡지 않게 — 위아래로 조금(BAND_MARGIN) 여유를 둔다
    cropRect(video) {
      const vw = video.videoWidth;
      const vh = video.videoHeight;
      const ew = video.clientWidth || vw;
      const eh = video.clientHeight || vh;
      const scale = Math.max(ew / vw, eh / vh);
      const sw = Math.min(vw, ew / scale);
      const sh = Math.min(vh, (eh / scale) * BAND_MARGIN);
      return { sx: (vw - sw) / 2, sy: (vh - sh) / 2, sw, sh };
    },
    // 카메라 인식 — 서버 확인을 기다리지 않고 바로 진동·삑(실패면 처리 뒤 낮은 음 두 번)
    onDetected(v) {
      if (this.busy || isStepLocked(Date.now(), this._lockUntil || 0)) return;
      this.feedback(true);
      this.handle(v, true);
    },
    onManual() {
      const v = this.manual.trim();
      this.manual = '';
      if (isStepLocked(Date.now(), this._lockUntil || 0)) {
        if (v) this.say('请稍等再扫(잠시 후 다시 스캔하세요)', true);
        return;
      }
      if (v) this.handle(v);
    },
    // 파일 입력 — ②: 사진으로 올린다 / ①③: 사진 한 장에서 바코드 인식
    onPhotoInput(e) {
      const files = Array.from((e.target && e.target.files) || []);
      if (e.target) e.target.value = '';
      if (!files.length) return;
      if (this.step === 2) {
        files.forEach(f => this.enqueue(f));
        return;
      }
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const v = await this.decodeSrc(reader.result);
          if (v) this.handle(v);
          else { this.say('照片里没识别到条码', true); this.feedback(false); }
        } catch (err) {
          console.error('[手机入仓] 사진 바코드 인식 오류:', err);
          this.say('识别错误: ' + err.message, true);
        }
      };
      reader.onerror = () => console.error('[手机入仓] 사진 읽기 실패:', files[0].name);
      reader.readAsDataURL(files[0]);
    },
    async handle(v, beeped) {
      if (this.step !== 1 && this.step !== 3) return;
      if (this.busy) return;
      this.busy = true;
      let ok = false;
      try {
        if (this.step === 1) ok = this.isPhoto ? await this.findOrder(v) : await this.findWaybill(v);
        else ok = this.setLocation(v);
      } catch (e) {
        console.error('[手机入仓] 처리 오류:', e);
        this.say('错误: ' + e.message, true);
      } finally {
        this.busy = false;
        if (!beeped || !ok) this.feedback(ok);
      }
    },
    // ① 운송장으로 订单列表 건 찾기 — PC 와 같은 API(type=tracking)
    async findWaybill(v) {
      const { data } = await axios.post('/api/warehouse/inboundRegister/find', { value: v, type: 'tracking' });
      if (data.요청결과 !== '성공') {
        this.say('搜索失败: ' + errText(data), true);
        return false;
      }
      const rows = (data.rows || []).map(r => this.decorate(r));
      if (!rows.length) return this.saveUnmatched(v, data.others || []);
      this.waybill = v;
      this.rows = rows;
      this.others = data.others || [];
      this.log('📦 ' + v + ' — ' + rows.length + '件' + this.ownerTag(rows), true);
      this.goStep(2);
      return true;
    },
    // 入库拍照 ① — 고른 종류(快递/货主/1688)로 찾기. 入库处理 검색과 같은 규칙(구매취소 제외)
    async findOrder(v) {
      const { data } = await axios.post('/api/importPhotoQueue/search', { 검색타입: this.searchType, 검색어: v, 작업자이름: this.workerName });
      if (data.요청결과 !== '성공') {
        this.say('搜索失败: ' + errText(data), true);
        return false;
      }
      const rows = (data.rows || []).map(r => this.decorate(r));
      if (!rows.length) {
        this.say('未找到: ' + this.typeLabel + ' ' + v + ' — 请确认单号种类', true);
        return false;
      }
      this.waybill = v;
      this.rows = rows;
      this.others = [];
      this.log('📦 ' + this.typeLabel + ' ' + v + ' — ' + rows.length + '件' + this.ownerTag(rows), true);
      this.goStep(2);
      return true;
    },
    // 入库拍照 — 完成: 대기열에 한 줄(PC 入库处理 하단). 사진은 찍을 때 이미 붙었다
    async finish() {
      if (this.saving) return;
      const rows = this.checkedRows;
      if (!rows.length) return this.say('请选择商品', true);
      this.saving = true;
      let ok = false;
      try {
        const { data } = await axios.post('/api/importPhotoQueue/create', {
          검색타입: this.searchType, 번호: this.waybill, reqIds: rows.map(r => r._id), 사진수: this.photos.length, 작업자이름: this.workerName
        });
        if (data.요청결과 !== '성공') {
          this.say('发送失败: ' + errText(data), true);
          return;
        }
        ok = true;
        this.log('✅ ' + this.typeLabel + ' ' + this.waybill + ' · ' + rows.length + '件 · 📷' + this.photos.length + ' · 已发送到电脑', true);
        this.reset();
        this.say('✅ 已完成 — 请扫下一个单号');
      } catch (e) {
        console.error('[入库拍照] 완료 전송 오류:', e);
        this.say('发送错误: ' + e.message, true);
      } finally {
        this.saving = false;
        this.feedback(ok);
      }
    },
    // ① 못 찾음 — 그 운송장으로 「도착 운송장」 임시 기록을 먼저 저장하고 촬영으로 넘어간다(2026-10-04 YZY).
    // 같은 번호로 매칭 안 된 기록이 이미 있으면 서버가 그걸 돌려준다(사진이 거기 이어 붙는다)
    async saveUnmatched(v, others) {
      if (!WAYBILL_RE.test(v)) {
        this.say('未找到: ' + v + ' · 单号格式不对，无法保存', true);
        return false;
      }
      const { data } = await axios.post('/api/warehouse/inboundRegister/unmatched/create', { 운송장번호: v });
      if (data.요청결과 !== '성공') {
        this.say('未找到，保存失败: ' + errText(data), true);
        return false;
      }
      this.waybill = v;
      this.unmatched = String(data.log._id);
      this.rows = [];
      this.others = others;
      const n = (data.log.사진 || []).length;
      // 안내는 이 기록 한 줄만(화면 맨 아래) — 요약칸 배너·메시지로 또 띄우지 않는다
      this.log('⚠ ' + v + ' — 系统未找到，已按快递单号保存，请继续拍照（之后在电脑上匹配订单）' + (data.reused ? ' · 已有记录' + (n ? ' 📷' + n : '') : ''), false);
      this.goStep(2);
      return true;
    },
    // ③ 위치번호 — 형식만 보고 받는다(목록에 없는 번호도 PC 처럼 그대로 저장 가능)
    setLocation(v) {
      // 형식 밖·바코드꼴(숫자 8자리 이상)·운송장과 같은 값은 받지 않고 칸을 비운다 — 乱码가 그대로 入仓되던 문제(2026-11-01 崔凡)
      const chk = checkLocation(v, this.waybill);
      if (!chk.ok) {
        this.manual = '';
        this.say(locationRejectText(chk.reason, v), true);
        return false;
      }
      const loc = chk.value;
      this.location = loc;
      this.goStep(4);
      this.autoSave = true;
      this.tryAutoSave();
      return true;
    },
    // 자동 入仓 — 한 번만(autoSave 를 먼저 내린다). 사진 업로드 중이면 기다리고, 실패한 사진이 있으면 멈추고 버튼으로
    tryAutoSave() {
      if (!this.autoSave || this.step !== 4 || this.saving) return;
      if (this.queue.some(q => q.error)) {
        this.autoSave = false;
        this.say('有照片上传失败 — 请返回重试，或直接按「入仓」', true);
        return;
      }
      if (this.queue.length) {
        this.say('照片上传完后自动入仓…');
        return;
      }
      this.autoSave = false;
      // 바로 저장하지 않고 잠깐 기다린다 — 그 사이 「重扫位置号」로 틀린 값을 고칠 수 있다(goStep 이 타이머를 끈다)
      this.say('位置号 ' + this.location + ' — 即将入仓，不对请点「重扫位置号」(곧 입고 등록됩니다. 틀리면 다시 스캔)');
      clearTimeout(this._autoTimer);
      this._autoTimer = setTimeout(() => this.save(), AUTOSAVE_DELAY_MS);
    },
    // ④ 入仓(系统未找到) — 임시 기록에 위치만 저장. 주문 매칭은 PC 에서
    async saveUnmatchedLocation() {
      this.saving = true;
      let ok = false;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/unmatched/save', { logId: this.unmatched, 위치번호: this.location });
        if (data.요청결과 !== '성공') {
          this.say('保存失败: ' + errText(data), true);
          return;
        }
        ok = true;
        this.log('✅ ' + this.waybill + ' → ' + this.location + ' · 系统未找到' + (this.photos.length ? ' · 📷' + this.photos.length : ''), true);
        this.reset();
        this.say('✅ 已保存 — 请在电脑上匹配订单 · 请扫下一个快递单号');
      } catch (e) {
        console.error('[手机入仓] 미매칭 저장 오류:', e);
        this.say('保存错误: ' + e.message, true);
      } finally {
        this.saving = false;
        this.feedback(ok);
      }
    },
    // ② 셔터 — 지금 프레임을 JPEG 로 떠서 바로 업로드 대기열(ImportPhotoMobile 과 같다)
    capture() {
      const v = this.$refs.video;
      if (!v || !v.videoWidth || !v.videoHeight) return;
      const scale = Math.min(1, CAPTURE_MAX_SIDE / Math.max(v.videoWidth, v.videoHeight));
      const w = Math.round(v.videoWidth * scale);
      const h = Math.round(v.videoHeight * scale);
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(v, 0, 0, w, h);
      this.flash = true;
      setTimeout(() => { this.flash = false; }, 120);
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('[手机入仓] 캡처 실패 — toBlob null');
          this.say('拍照失败', true);
          return;
        }
        this.enqueue(new File([blob], 'cam_' + Date.now() + '.jpg', { type: 'image/jpeg' }));
      }, 'image/jpeg', CAPTURE_QUALITY);
    },
    revoke(q) {
      try {
        URL.revokeObjectURL(q.preview);
      } catch (e) {
        console.error('[手机入仓] 미리보기 해제 실패', e);
      }
    },
    enqueue(file) {
      // kind = 찍을 때 고른 종류(入库拍照). 入仓登记 은 늘 商品照片
      this.queue.push({ key: Date.now() + '_' + Math.random().toString(36).slice(2, 8), file, preview: URL.createObjectURL(file), error: '', kind: this.isPhoto ? this.photoKind : PHOTO_KIND });
      this.pump();
    },
    retry(q) {
      q.error = '';
      this.pump();
    },
    // 사진 한 장 = S3 한 번 → 체크된 행마다 importPhoto/add(행별 촬영 토큰은 issue 로 받는다 — PC 「上传照片」과 같은 길)
    async attach(url, rows) {
      for (const r of rows) {
        const { data: tk } = await axios.post('/api/importPhoto/issue', { _id: r._id });
        if (tk.요청결과 !== '성공') throw new Error((tk.error && tk.error.errorMessage) || 'issue fail');
        const { data } = await axios.post('/api/importPhoto/add', { id: tk.id, e: tk.exp, t: tk.token, 종류: PHOTO_KIND, urls: [url] });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'add fail');
      }
    },
    async pump() {
      if (this.working) return;
      this.working = true;
      try {
        let q;
        while ((q = this.queue.find(x => !x.error))) {
          const rows = this.checkedRows;
          const unm = this.unmatched;
          try {
            if (unm) {
              // 系统未找到 — 임시 기록에 붙인다(매칭할 때 고른 구매 건으로 옮겨진다)
              const url0 = await uploadImportPhoto(q.file, 'unmatched-' + unm);
              const { data } = await axios.post('/api/warehouse/inboundRegister/unmatched/photo', { logId: unm, urls: [url0] });
              if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'photo fail');
              if (!this.queue.includes(q)) continue;
              this.photos.push(url0);
              this.revoke(q);
              this.queue = this.queue.filter(x => x !== q);
              this.say('✅ 上传完成 ' + this.photos.length + '张');
              continue;
            }
            if (!rows.length) throw new Error('请选择商品');
            const url = await uploadImportPhoto(q.file, rows[0]._id);
            if (this.isPhoto) {
              // 入库拍照 — 고른 건마다 한 번에 붙이고 작업자를 남긴다(서버 importPhotoQueue/photo)
              const { data } = await axios.post('/api/importPhotoQueue/photo', { reqIds: rows.map(r => r._id), 종류: q.kind, url, 작업자이름: this.workerName });
              if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'photo fail');
            } else {
              await this.attach(url, rows);
            }
            // 올라가는 사이 「처음부터」로 비웠으면 이 화면 목록에는 넣지 않는다(그 건에는 이미 붙었다)
            if (!this.queue.includes(q)) continue;
            this.photos.push(url);
            if (q.kind === '사이즈사진') this.sizeCount++;
            this.revoke(q);
            this.queue = this.queue.filter(x => x !== q);
            this.say('✅ 上传完成 ' + this.photos.length + '张');
          } catch (e) {
            console.error('[手机入仓] 사진 업로드 실패', e);
            q.error = e.message || 'fail';
            this.say('上传失败: ' + q.error, true);
          }
        }
      } finally {
        this.working = false;
      }
    },
    // ④ 入仓 — PC 「保存」과 같은 API(ids·위치번호·운송장번호)
    async save() {
      clearTimeout(this._autoTimer);
      if (this.saving) return;
      if (this.unmatched) return this.saveUnmatchedLocation();
      const rows = this.checkedRows;
      if (!rows.length) return this.say('请选择商品', true);
      this.saving = true;
      let ok = false;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/save', {
          ids: rows.map(r => r._id), 위치번호: this.location, 운송장번호: this.waybill
        });
        if (data.요청결과 !== '성공') {
          this.say('保存失败: ' + errText(data), true);
          return;
        }
        ok = true;
        const n = (data.savedIds || []).length;
        this.log('✅ ' + this.waybill + ' → ' + this.location + ' · ' + n + '件' + this.ownerTag(rows) + (this.photos.length ? ' · 📷' + this.photos.length : '') +
          (data.skipped ? ' · 已入库未保存 ' + data.skipped : ''), true);
        this.reset();
        this.say('✅ 入仓完成 — 请扫下一个快递单号');
      } catch (e) {
        console.error('[手机入仓] 저장 오류:', e);
        this.say('保存错误: ' + e.message, true);
      } finally {
        this.saving = false;
        this.feedback(ok);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.minreg {
  max-width: 520px;
  margin: 0 auto;
  padding: 8px;
  font-size: 15px;
  &__steps { display: flex; gap: 4px; margin-bottom: 8px; }
  &__stepdot {
    flex: 1;
    padding: 6px 2px;
    border: 1px solid #ccc;
    border-radius: 6px;
    text-align: center;
    font-size: 13px;
    color: #888;
    line-height: 1.2;
    b { display: block; font-size: 16px; }
    small { display: block; font-size: 10px; }
    &.is-on { border-color: #3b6fd8; background: #3b6fd8; color: #fff; }
    &.is-done { border-color: #28a745; color: #1e7e34; background: #eafaf0; }
  }
  // 入库拍照 — 작업자 이름 · 단호/사진 종류 버튼
  &__who { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; small { flex: none; } }
  &__types { display: flex; gap: 4px; margin-bottom: 6px; .btn { flex: 1; padding: 8px 2px; font-weight: 600; } }
  &__sum { padding: 6px 8px; border: 1px solid #ddd; border-radius: 8px; background: #fafafa; margin-bottom: 6px; }
  // 행이 많아도 촬영 화면이 아래로 밀리지 않게 — 목록만 안에서 스크롤
  &__rows { max-height: 22vh; overflow-y: auto; }
  &__row { padding: 4px 0; border-top: 1px dashed #e3e3e3; font-size: 14px; &.is-rocket { color: #d63333; font-weight: bold; } }
  &__rtext { min-width: 0; word-break: break-all; }
  &__pimg { width: 40px; height: 40px; object-fit: cover; flex: none; border-radius: 4px; }
  &__loc { font-size: 24px; color: #1e7e34; }
  &__cam {
    position: relative;
    margin: 8px 0;
    min-height: 160px;
    background: #111;
    border-radius: 8px;
    overflow: hidden;
    video { width: 100%; display: none; &.is-on { display: block; } }
    // ①③ 바코드 한 줄만 보이는 띠 — 영상은 가운데를 꽉 채워 잘라 보인다(cropRect 와 같은 계산)
    &.is-band {
      min-height: 0;
      height: 120px;
      video { height: 100%; object-fit: cover; }
      .minreg__cam-off { flex-direction: row; flex-wrap: wrap; gap: 6px; .btn-lg { padding: 6px 12px; font-size: 16px; } .mt-2 { margin-top: 0 !important; } }
      .minreg__cam-hint { padding: 2px; font-size: 12px; }
    }
    // ② 촬영 — 세로 카메라(1080×1920)를 폭에 맞추면 화면보다 길어져 매번 스크롤해야 했다(2026-10-04 YZY).
    // 남은 높이에 맞춰 자르고, 영상은 잘리지 않게 contain(찍히는 범위 = 보이는 범위보다 넓지 않다)
    &.is-photo {
      min-height: 0;
      height: 42vh;
      height: clamp(180px, calc(100vh - 360px), 56vh);
      height: clamp(180px, calc(100dvh - 360px), 56dvh);
      video { height: 100%; object-fit: contain; }
    }
  }
  &__aim { position: absolute; left: 6%; right: 6%; top: 50%; height: 2px; background: rgba(255, 60, 60, .85); pointer-events: none; }
  &__cam-off {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    padding: 8px;
  }
  &__cam-hint { position: absolute; left: 0; right: 0; top: 0; padding: 6px; text-align: center; color: #fff; font-size: 14px; background: rgba(0, 0, 0, .45); }
  &__engine { position: absolute; left: 6px; bottom: 4px; font-size: 11px; color: #ddd; }
  &__flash { position: absolute; inset: 0; background: rgba(255, 255, 255, .6); pointer-events: none; }
  &__shutter {
    position: absolute;
    left: 50%;
    bottom: 12px;
    transform: translateX(-50%);
    width: 72px;
    height: 72px;
    border-radius: 50%;
    border: 6px solid rgba(255, 255, 255, .6);
    background: #fff;
    &:active { transform: translateX(-50%) scale(.92); }
    &:disabled { opacity: .4; }
  }
  &__input { display: flex; gap: 6px; input { font-size: 17px; } }
  &__msg { margin-top: 8px; padding: 8px 10px; border-radius: 6px; background: #eafaf0; color: #1e7e34; font-size: 14px; &.is-err { background: #fdecea; color: #c0392b; } }
  &__nav {
    display: flex;
    gap: 6px;
    margin-top: 8px;
    .btn { flex: 1; padding: 12px 4px; font-weight: 600; }
    small { display: block; font-size: 11px; font-weight: 400; }
    // ② 다음 단계 버튼은 화면 아래에 붙인다 — 사진이 쌓여도 스크롤 없이 누른다
    &.is-fixed { position: sticky; bottom: 0; z-index: 5; margin: 8px -8px 0; padding: 6px 8px calc(6px + env(safe-area-inset-bottom)); background: #fff; box-shadow: 0 -2px 6px rgba(0, 0, 0, .08); }
  }
  &__grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 4px; margin-top: 8px; }
  &__cell {
    position: relative;
    padding-top: 100%;
    border-radius: 6px;
    overflow: hidden;
    background: #f1f1f1;
    img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
    &.is-pending img { opacity: .55; }
  }
  &__badge { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); padding: 2px 4px; border-radius: 4px; font-size: 11px; color: #fff; background: rgba(0, 0, 0, .55); white-space: nowrap; &.is-err { background: #dc3545; } }
  &__logs { margin-top: 8px; }
  &__log {
    padding: 6px 8px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    &.is-ok { color: #1e7e34; }
    &.is-err { color: #c82333; background: #fff5f5; }
  }
  &__time { color: #999; font-size: 12px; }
}
</style>
